import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AppPanel from '../fw/AppPanel.react';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import AddButton, {AddButtonAbove} from '../fw/AddButton.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'billingRuleList.title', 'defaultMessage': 'Billing rule list'}
});

interface BillingRuleListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class BillingRuleList extends React.Component<BillingRuleListProps> {

    typeName = 'billingRules';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const {billingRules} = this.props.user.organisation;
        const list = billingRules;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <div>
                    <AddButtonAbove list={list.edges} metadata={type} organisationId={this.props.user.organisation.realId} parent={this.props.user.organisation} urlMapping={urlMapping} />

                    <PagingGrid
                        columns={['flowDef.name', 'flow.flowTitle', 'billingNote', 'validSince', 'validTo']}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        urlMapping={urlMapping}
                    />

                    <AddButton metadata={type} organisationId={this.props.user.organisation.realId} parent={this.props.user.organisation} urlMapping={urlMapping} />
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(BillingRuleList), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    billingRules(first: $first, after: $after, before: $before, last: $last) {
                        edges {
                            node {
                                id,
                                billingNote,
                                validSince,
                                validTo,
                                flow_id,
                                flow {
                                    id,
                                    realId,
                                    flowTitle,
                                    name,
                                },        
                                flowDef_id,
                                flowDef {
                                    id,
                                    name,
                                },
                                organisation {
                                    id
                                },
                                organisation_id,
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    }
                }
            }
        `,
    },
});
